var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.path=='/home'||
	_vm.$route.path=='/dynamic'||
	_vm.$route.path=='/newsList'||
	_vm.$route.path=='/industryList'||
	_vm.$route.path=='/safetyList'||
	_vm.$route.path=='/skillList'||
	_vm.$route.path=='/exhibition'||
	_vm.$route.path=='/peixunTxt'||
	_vm.$route.path=='/dangTxt'||
	_vm.$route.path=='/dynamicMsg'||
	_vm.$route.path=='/study'||
	_vm.$route.path=='/studyMsg'||
	_vm.$route.path=='/cardSeach'||
	_vm.$route.path=='/download')?_c('div',[_c('div',{staticClass:"headbox fcss"},[_c('Headbox')],1),_c('div',{staticClass:"home_msg"},[_c('router-view')],1)]):(_vm.$route.path=='/login'||
	_vm.$route.path=='/reg'||
	_vm.$route.path=='/qyInfoRemake'||
	_vm.$route.path=='/cpwd'||
	_vm.$route.path=='/classProblem'||
	_vm.$route.path=='/classShuati'||
	_vm.$route.path=='/classTest'||
	_vm.$route.path=='/classVideo')?_c('div',[_c('div',{staticClass:"home_msg"},[_c('router-view')],1)]):_c('div',[(_vm.$route.path=='/userNews')?_c('div',{staticClass:"home_msgU"},[_c('div',{staticClass:"r",staticStyle:{"width":"100%"}},[_c('userHead'),_c('div',{staticClass:"msg"},[_c('router-view')],1)],1)]):_c('div',{staticClass:"home_msgU"},[_c('div',{staticClass:"l"},[_c('userLeft')],1),_c('div',{staticClass:"r"},[_c('userHead'),_c('div',{staticClass:"msg"},[_c('router-view')],1)],1)])]),(_vm.isfot&&_vm.$route.path!='/login'&&_vm.$route.path!='/reg'&&_vm.$route.path!='/cpwd'&&_vm.$route.path!='/classProblem'&&_vm.$route.path!='/classTest'&&_vm.$route.path!='/classVideo')?_c('div',{staticClass:"Footbox"},[_c('Footbox')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }